import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-select-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: ['.form-select-field { display:flex;     flex: 1; } '],
  template: `
    <p-iftalabel class="flex-1">
      <p-select
        [options]="$any(field.props.options)"
        [formControl]="formControl"
        [optionValue]="'id'"
        [formlyAttributes]="field"
        class="w-full flex"
        optionLabel="name"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
        [placeholder]="
          field.props['translate']
            ? (field.props.placeholder || '' | translate)
            : field.props.placeholder
        "
      />

      <label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}</label>
    </p-iftalabel>
  `,
})
export class FormSelectFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-select-field';
}
